import Log, { Logger } from "sap/base/Log";
import BaseController from "../controller/BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";
import Event from "sap/ui/base/Event";
import { EnvironmentService } from "../service/Environment.service";
import { AuthService } from "../service/Auth.service";

/**
 * @namespace com.unitrade.crm.blocks
 */
export default class ReportsBlock extends BaseController {
  private _logger: Logger;
  private _metaModel: JSONModel;
  private _umsaetze: JSONModel;
  private _umsaetzeMonthly: JSONModel;
  private _authService = new AuthService();


  onInit(): void {
    this._logger = Log.getLogger("com.unitrade.crm.blocks.ReportsBlock");
    const config = this._authService.getUserConfiguration();
    this._metaModel = new JSONModel({
      busy: false,
      showYearlyUmsatz: config.useMvKundenumsatz
    });
    this._umsaetze = new JSONModel();
    this._umsaetzeMonthly = new JSONModel();
    this.setModel(this._metaModel, "meta");
    this.setModel(this._umsaetze, "umsaetze");
    this.setModel(this._umsaetzeMonthly, "umsaetzeMonthly");

    this.onModelContextChange = this.onModelContextChange.bind(this);
    this.getView().attachModelContextChange(null, this.onModelContextChange);
  }

  onExit(): void {
    this.getView().detachModelContextChange(this.onModelContextChange);
  }

  async onModelContextChange(oEvent: Event) {
    this._metaModel.setProperty("/busy", true);
    const oCustomerModel = this.getModel("Customer");
    if (oCustomerModel) {
      const kundId = oCustomerModel.getProperty("/id");
      const kundLfd = oCustomerModel.getProperty("/lfd");
      if (!!kundId && !!kundLfd) {
        this._logger.debug(`model context changed to kunde ${kundId}/${kundLfd}`);
        try {
          await this.loadYearly(kundId);
          await this.loadMonthly(kundId);
        } finally {
          this._metaModel.setProperty("/busy", false);
        }
      }
    }
  }

  async loadYearly(kundId: number) {
    if(this._metaModel.getProperty("/showYearlyUmsatz")) {
      const url = `${EnvironmentService.getBaseUrl()}/reporting/kunde/${kundId}/yearly`;
      const umsatzData = (await $.ajax(url)) as KundenUmsatz[];
      const labels = umsatzData.map((u) => u.jahr.toString());
      const data = umsatzData.map((u) => u.umsatz);
      const dataSet = [{ label: "Umsatz", data: data }];
      this._umsaetze.setProperty("/labels", labels);
      this._umsaetze.setProperty("/dataset", dataSet);
    }
  }

  async loadMonthly(kundId: number) {
    const url = `${EnvironmentService.getBaseUrl()}/reporting/kunde/${kundId}/monthly`;
    const umsatzData = (await $.ajax(url)) as KundenUmsatzMonthly[];
    const labels = [...new Set(umsatzData.map((u) => u.monat))];

    const grouped = this.groupBy(umsatzData, (d: KundenUmsatzMonthly) => d.jahr);
    const dataset: any[] = [];

    grouped.forEach((value: KundenUmsatzMonthly[], key: number) => {
      const d = {
        label: "Umsatz " + key,
        data: value.map((v) => v.umsatz),
      };
      dataset.push(d);
    });

    this._umsaetzeMonthly.setProperty("/labels", labels);
    this._umsaetzeMonthly.setProperty("/dataset", dataset);
  }

  private groupBy(list: any, keyGetter: any) {
    const map = new Map();
    list.forEach((item: any) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }
}

interface KundenUmsatz {
  kundeId: number;
  jahr: number;
  betreuer1: string;
  betreuer2: string;
  umsatz: number;
  spanne: number;
  durchschnitt: number;
  db: number;
  besuchsberichte: number;
  anzahl: number;
}

interface KundenUmsatzMonthly {
  umsatz: number;
  jahr: number;
  monat: number;
}
